
import axios from "axios";
import PrestasiChart from "../components/Dashboard.js/BarChart";
import NetPayment from "../components/Dashboard.js/BottomCards/NetPayment";
import OverPayment from "../components/Dashboard.js/BottomCards/OverPyamnet";
import Performance from "../components/Dashboard.js/BottomCards/Performance";
import Kpi from "../components/Dashboard.js/Kpi";
import Notification from "../components/Dashboard.js/Notification";
import Bayaran from "../components/Dashboard.js/TopCards/Bayaran";
import Caj from "../components/Dashboard.js/TopCards/Caj";
import Tunggakan from "../components/Dashboard.js/TopCards/Tunggakan";
import AdminLayout from "../layout/AdminLayout";
import { useEffect, useState } from "react";

const Landing = () => {

  const [data, setData] = useState(null)

  const handleData = async () => {
    try {
      const res = await axios.get('https://bpohasil.ngrok.app/api/air-client')
      setData(res.data)

    } catch (error) {
      console.log(error)
    }

  }
  useEffect(() => {
    handleData();
  }, [])


  return (
    <AdminLayout>
      <div>
        <div className="grid lg:grid-cols-3 gap-5 mb-5">
          {data && <Bayaran data={data} />}
          {data && <Caj data={data} />}
          {data && <Tunggakan data={data} />}
        </div>
        {data && <PrestasiChart data={data} />}
        <div className="grid lg:grid-cols-3 gap-5 my-5">
          {data && <NetPayment data={data} />}
          <Performance />
          {data && <OverPayment data={data} />}
        </div>

        <div className="gap-5 grid lg:grid-cols-2">
          <Notification />
          <Kpi />
        </div>
      </div>
    </AdminLayout>
  );
}
export default Landing;